// Mini Zali Update: theme custom-event hooks.
//
// Enabled via the `useCustomEvents` flag in snippets/theme-globals.liquid, which
// makes theme.js dispatch DOM events for cart activity. The stock version of this
// file was console.log examples only; those are removed so the console stays clean.
//
// Events available (detail payload in brackets):
//   cart:item-added        { product }
//   cart:updated           { cart }
//   cart:error             { errorMessage }
//   quick-cart:open        { cart }
//   quick-cart:close
//   product:variant-change { variant }
//   product:quantity-update{ quantity, variant }
//   quickview:loaded

(function () {
  'use strict';

  var SELECTOR = '[data-mz-gift-progress]';

  // The PDP gift progress teaser is rendered by Liquid from the cart total at page
  // load, so after an ajax add-to-cart it shows a stale "spend $X more" figure until
  // the page is refreshed — precisely when the shopper has just acted on it.
  //
  // Re-render rather than recompute: the tier maths lives in
  // snippets/product-block-gift-progress.liquid and is deliberately kept in step with
  // snippets/cart-progress.liquid. Duplicating it here would give us a third copy to
  // keep in sync. Instead the section is re-requested and the block swapped, so Liquid
  // stays the single source of truth.
  var refreshing = false;

  function refreshGiftProgress() {
    var current = document.querySelector(SELECTOR);
    if (!current || refreshing) return;

    // Section id comes from the wrapping .shopify-section (id="shopify-section-<id>"),
    // so the snippet needs no extra plumbing to know which section it lives in.
    var wrapper = current.closest('.shopify-section');
    if (!wrapper || !wrapper.id) return;
    var sectionId = wrapper.id.replace(/^shopify-section-/, '');
    if (!sectionId) return;

    refreshing = true;
    // Cache-buster: ?section_id= responses are plain GETs and can be served from cache,
    // which would hand back the pre-add cart total and defeat the whole refresh.
    var url = window.location.pathname +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&_mz=' + Date.now();

    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('section fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SELECTOR);
        // Re-query: the DOM may have changed while the request was in flight.
        var target = document.querySelector(SELECTOR);
        if (!target) return;

        if (fresh) {
          target.replaceWith(fresh);
        } else {
          // Every tier cleared, or the block resolved to nothing for this currency.
          target.remove();
        }
      })
      .catch(function () {
        // Leave the stale-but-valid block in place rather than blanking the buy box.
      })
      .finally(function () {
        refreshing = false;
      });
  }

  document.addEventListener('cart:item-added', refreshGiftProgress);
  document.addEventListener('cart:updated', refreshGiftProgress);
})();
